const ORGANISATION_PREFERENCES = {
  // Theme
  THEME_MAIN_COLOR: 'theme.main_color',
  THEME_PRIMARY_COLOR: 'theme.primary_color',
};

export default angular
  .module('sfMobile.constants.organisation-preferences', [])
  .constant('SF_ORGANISATION_PREFERENCES', ORGANISATION_PREFERENCES).name;
